module.exports = __webpack_public_path__ + "media/assets/certification_page/pyp-a38abd68c7923f0368fb3dc896ee138c3829eee1c5a7f2b6df74a63475669979.svg";